import styled from "styled-components";
import { SIDEBAR_W, TOPBAR_H } from "../../config/layout";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding-top: ${TOPBAR_H};
`;

/* Márgenes del diseño: 119px a la izquierda de la barra lateral y 377px a la
   derecha. En pantallas más estrechas el margen derecho se reduce para que las
   dos columnas de tarjetas sigan siendo legibles. */
export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  padding: 28px 377px 28px 119px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 1500px) { padding-right: 119px; }
  @media (max-width: 900px)  { padding: 28px 24px; }
`;

export const SectionTitle = styled.h1`
  margin: 0;
  font-size: 1.9rem;
  font-weight: 700;
  color: #2F6D92;
`;

/* Los filtros van sobre una píldora blanca, como en el diseño */
export const TabsRow = styled.div`
  align-self: flex-start;
  display: inline-flex;
  gap: 4px;
  align-items: center;
  background: #fff;
  border-radius: 999px;
  padding: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
`;

export const Tab = styled.button`
  padding: 6px 18px;
  border-radius: 20px;
  border: none;
  background: ${({ $active }) => ($active ? "#2F6D92" : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "#666")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${({ $active }) => ($active ? "#2F6D92" : "#dce8f0")};
    color: ${({ $active }) => ($active ? "#fff" : "#2F6D92")};
  }
`;

export const ActivitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

// $isNew: prescripción que el paciente aún no ha abierto. El borde transparente
// en las demás evita que la tarjeta cambie de tamaño al dejar de ser nueva.
export const ActivityCard = styled.div`
  background: ${({ $isNew }) => ($isNew ? "#FEF1EC" : "#fff")};
  border: 2px solid ${({ $isNew }) => ($isNew ? "#F4A072" : "transparent")};
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.07);
  padding: 18px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

// El PNG ya trae su propio fondo, asi que no lleva envoltorio de color.
export const CardIcon = styled.img`
  width: 42px;
  height: 42px;
  flex-shrink: 0;
`;

export const CardName = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1b3a6b;
  flex: 1;
`;

export const NewBadge = styled.span`
  padding: 3px 10px;
  border-radius: 12px;
  background: #F09A6B;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
`;

export const TagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Tag = styled.span`
  padding: 3px 10px;
  border-radius: 12px;
  background: #ede9f8;
  color: #7b61c4;
  font-size: 0.75rem;
  font-weight: 500;
`;

export const GoalLabel = styled.p`
  margin: 4px 0 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const GoalText = styled.p`
  margin: 0;
  font-size: 0.85rem;
  color: #55636e;
  line-height: 1.5;
  flex: 1;
  /* El objetivo puede venir numerado en varias lineas desde el Excel, y el
     texto de la BD trae saltos \r\n. */
  white-space: pre-line;
`;

export const CardButton = styled.button`
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: #79BEE6;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  width: 100%;

  &:hover { background: #1d8f9b; }
`;
